import { Text, XStack, YStack } from "tamagui";
import { kiosk } from "../kioskTheme";
import { Card } from "./ConfirmParts";

const Btn = ({ active, onPress, children }: { active?: boolean; onPress: () => void; children: React.ReactNode }) => (
  <YStack
    flex={1}
    ai="center"
    jc="center"
    height={46}
    borderRadius={12}
    cursor="pointer"
    onPress={onPress}
    backgroundColor={active ? "#EFF6FF" : "#fff"}
    borderWidth={1.5}
    borderColor={active ? kiosk.blue : kiosk.line}
    pressStyle={{ opacity: 0.9 }}>
    <Text fontSize={14} fontWeight="800" color={active ? kiosk.blue : kiosk.ink}>
      {children}
    </Text>
  </YStack>
);

/**
 * 結帳頁「配案選擇（是否需要瓦斯配件）」：新客戶首次配送是否需要一併安裝配件。
 * 只需按是/否；需要則由專員到府確認規格與報價。TODO：送後端。
 */
const AccessoryCard = ({ value, onChange }: { value: boolean | null; onChange: (v: boolean) => void }) => (
  <>
    <XStack ai="center" gap={8} mt={16} mb={8} ml={4}>
      <Text fontSize={13} fontWeight="800" color={kiosk.blueD} letterSpacing={0.8}>
        是否需要瓦斯配件
      </Text>
      <Text fontSize={11.5} fontWeight="800" color="#059669" backgroundColor="#ECFDF5" borderColor="#A7F3D0" borderWidth={1} borderRadius={999} px={8} py={1.5}>
        選填
      </Text>
    </XStack>
    <Card>
      <YStack py={4} gap={12}>
        <Text fontSize={13} color={kiosk.grey} lineHeight={20}>
          配送是否需要一併安裝瓦斯配件（調整器、軟管、安全裝置等）？由專員到府確認規格與報價。
        </Text>
        <XStack gap={10}>
          <Btn active={value === true} onPress={() => onChange(true)}>
            需要
          </Btn>
          <Btn active={value === false} onPress={() => onChange(false)}>
            不需要
          </Btn>
        </XStack>
      </YStack>
    </Card>
  </>
);

export default AccessoryCard;
